import React, { useState } from 'react';
import classNames from 'classnames';

import lang from '../../../../../lib/language';
import { RatiosPeriodType } from '../../../../../lib/models/fundamental/types';

import iconExpandUp from '../../../../../assets/img/icon_expan_down_ratios.svg';
import { ClickableDiv } from '../../../../../components';
import { useIsMobile } from '../../../../../hooks';
import MobileDrawer from '../../../../../shared_components/MobileDrawer/MobileDrawer';

import styles from './TimeOptionsModal.module.scss';

type TimeOptionsModalProps = {
  options: string[];
  currentOption: string;
  onTimeChange: (index: number) => void;
  isDisabled: boolean;
  currentPeriod: string;
};

const TimeOptionsModal: React.FC<TimeOptionsModalProps> = ({
  options,
  currentOption,
  onTimeChange,
  isDisabled = false,
  currentPeriod,
}) => {
  const { isMobile } = useIsMobile();
  const [isFilterModal, setFilterModal] = useState<boolean>(false);

  const handleOptionClick = (index: number) => {
    onTimeChange(index);
  };

  const capitalizeFirstLetter = (text: string | undefined) => {
    if (!text) return '';
    return text !== RatiosPeriodType.TTM ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : text;
  };

  const getTitle = () => {
    if (currentPeriod === RatiosPeriodType.QUARTERLY) {
      return lang.ratiosModalSelectQuarter();
    }
    if (currentPeriod === RatiosPeriodType.ANNUAL) {
      return lang.ratiosModalSelectYear();
    }

    return lang.ratiosModalSelectPeriod();
  };

  // The drawer is a mobile-only surface, so nothing of this control belongs on desktop.
  if (!isMobile) {
    return null;
  }

  return (
    <>
      {currentPeriod !== RatiosPeriodType.TTM && (
        <ClickableDiv
          disabled={isDisabled}
          onClick={() => {
            if (!isDisabled) {
              setFilterModal(true);
            }
          }}
        >
          <div className={styles.wrapper}>
            <div className={styles.title}>
              <div
                className={classNames(
                  styles.titleText,
                  isDisabled ? styles.titleTextDisabled : styles.titleTextEnabled,
                )}
              >
                {isDisabled ? lang.commonNA() : capitalizeFirstLetter(currentOption)}
                <img
                  className={isDisabled ? styles.iconDisabled : styles.icon}
                  src={iconExpandUp}
                  alt="icon filter"
                />
              </div>
            </div>
          </div>
        </ClickableDiv>
      )}
      <MobileDrawer
        isOpen={isFilterModal}
        title={getTitle()}
        onClose={() => setFilterModal(false)}
        usePortal
      >
        <div className={styles.rangeButtonWrapper}>
          {options.map((option, index) => (
            <ClickableDiv
              key={option}
              onClick={() => handleOptionClick(index)}
              className={styles.rangeButton}
            >
              <span
                className={
                  option === currentOption
                    ? styles.rangeButtonTextActive
                    : styles.rangeButtonText
                }
              >
                {option}
              </span>
            </ClickableDiv>
          ))}
        </div>
      </MobileDrawer>
    </>
  );
};

export default TimeOptionsModal;
